import ProjectQaPaintInspectionsIndex from "./index";
import NewProjectQaPaintInspections from "./new";
import EditProjectQaPaintInspection from "./edit";

export default [
  { path: "/project/:project_id/qa/paint_inspections/:id/edit", component: EditProjectQaPaintInspection, name: "Edit ProjectQaPaintInspection" },
  { path: "/project/:project_id/qa/paint_inspections/new", component: NewProjectQaPaintInspections, name: "Show ProjectQaPaintInspection" },
  { path: "/project/qa/paint_inspections", component: ProjectQaPaintInspectionsIndex, name: "Paint Inspections" },
];
